declare var google: any;
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-share-tracking',
  templateUrl: './share-tracking.component.html',
  styleUrls: ['./share-tracking.component.css']
})
export class ShareTrackingComponent implements OnInit, OnDestroy {
  id: any;
  bookingId: any = '';
  public lat: any = 28.6139;
  public markers = '/assets/images/ambulance1.png';
  public lng: any = 77.2090;
  public origin: any;
  public destination: any;
  searchResultData: any = [];
  zoom: number = 7;
  polylines: any = [];

  constructor(
    public auth: AuthService,
    private toaster: ToastrService,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getMapData();
    this.id = setInterval(() => { this.getMapData(); }, 2000);
    this.auth.getLocation().then(() => {});
  }

  ngOnDestroy(): void {
    clearInterval(this.id);
    localStorage.removeItem('ambulanceBook');
  }

  res: any;
  isEmpty(obj: any) { return Object.keys(obj).length === 0; }

  getMapData() {
    this.auth.getMapData().subscribe((res: any) => {
      this.res = res;
      if (this.isEmpty(res['data'])) { this.completeBooking(); return; }
      this.bookingId = this.res['data'][0]['_id'] || '';
      if (res['data']) {
        if (res['data'][0]['status'] === 'PENDING') {
          this.lat = this.res['data'][0]['bookingLocation']['coordinates'][1];
          this.lng = this.res['data'][0]['bookingLocation']['coordinates'][0];
          this.destination = { lat: this.lat, lng: this.lng };
          this.origin = { lat: this.lat, lng: this.lng };
          this.toaster.info('We are working on your booking', 'Message', { timeOut: 2000 });
        } else {
          this.setGraph();
        }
      }
    }, (err: any) => { console.error(err); });
  }

  setGraph() {
    if (this.searchResultData.length) {
      this.searchResultData[0].lat = this.res['data'][0]['ambulanceLocation']['coordinates'][1];
      this.searchResultData[0].lng = this.res['data'][0]['ambulanceLocation']['coordinates'][0];
      this.destination = { lat: this.res['data'][0]['bookingLocation']['coordinates'][1], lng: this.res['data'][0]['bookingLocation']['coordinates'][0] };
      this.origin = { lat: this.res['data'][0]['ambulanceLocation']['coordinates'][1], lng: this.res['data'][0]['ambulanceLocation']['coordinates'][0] };
      this.searchResultData[1].lat = this.res['data'][0]['bookingLocation']['coordinates'][1];
      this.searchResultData[1].lng = this.res['data'][0]['bookingLocation']['coordinates'][0];
    } else {
      this.destination = { lat: this.res['data'][0]['bookingLocation']['coordinates'][1], lng: this.res['data'][0]['bookingLocation']['coordinates'][0] };
      this.origin = { lat: this.res['data'][0]['ambulanceLocation']['coordinates'][1], lng: this.res['data'][0]['ambulanceLocation']['coordinates'][0] };
      this.searchResultData = [
        { lat: this.res['data'][0]['ambulanceLocation']['coordinates'][1], lng: this.res['data'][0]['ambulanceLocation']['coordinates'][0], url: this.markers, name: this.res['data'][0]['ambulanceName'], contactNo: this.res['data'][0]['ambulancePhoneNo'] },
        { label: 'Booking', lat: this.res['data'][0]['bookingLocation']['coordinates'][1], lng: this.res['data'][0]['bookingLocation']['coordinates'][0], contactNo: this.res['data'][0]['userPhoneNo'], boookingAddress: this.res['data'][0]['boookingAddress'] }
      ];
    }
  }

  cancelBooking() {
    this.auth.cancelAmbulanceBooking(this.bookingId).subscribe(() => {
      document.getElementById('booking_cancel_popup_trigger')!.click();
      clearInterval(this.id);
    }, (err: any) => { console.error(err); });
  }

  completeBooking() {
    clearInterval(this.id);
    localStorage.removeItem('ambulanceBook');
    this.router.navigate(['/']);
  }

  redirectHomePage() {
    document.getElementById('booking_cancel_popup_trigger')!.click();
    this.router.navigate(['/']);
  }
}
